import { useSheetStore } from '@/shared/stores/sheet-store';

import { SaveServiceSheet } from './save-service-sheet-host/save-service-sheet';

// Mounted beside `QuickAddClient` and `ScheduleSessionDialog`, open while `services/save` is on
// top of the stack — it has no local mode of its own, since every caller opens it to add a
// service, never to edit one.
export function SaveServiceSheetHost() {
    const currentSheet = useSheetStore((state) => state.currentSheet);
    const closeCurrentSheet = useSheetStore((state) => state.closeCurrentSheet);

    const isOpen = currentSheet?.type === 'services/save';
    const onCreated = isOpen ? currentSheet.data?.onCreated : undefined;

    return (
        <SaveServiceSheet
            open={isOpen}
            // `SaveServiceSheet` calls this before `onSuccess` on a save too, so it alone pops the
            // stack — popping again in `onSuccess` would also close whatever sits beneath this sheet.
            onOpenChange={(open) => {
                if (!open) closeCurrentSheet();
            }}
            onSuccess={(code) => onCreated?.(code)}
        />
    );
}
